
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.006 3.897a.907.907 0 00-.907.908l-.007 6.287H4.798a.908.908 0 000 1.816h6.294v6.294a.908.908 0 001.816 0v-6.295h6.294a.908.908 0 000-1.815h-6.295V4.798a.912.912 0 00-.9-.901z"}})])
          )
        }
      }
    